import { Spinner } from '@cian/ui-kit';

import styles from './InfrastructureLoader.css';
import { FC } from 'react';

export const InfrastructureLoader: FC = () => {
  return (
    <div className={styles['wrapper']}>
      <Spinner size={40} />
    </div>
  );
};
